'use strict';

import MarkerClusterer from 'node-js-marker-clusterer';

// import InfoContent from './l2Components/InfoContent';

// const getInfoContent = content => {
//   return <InfoContent content={content} />;
// };

class MapCluster {
  constructor(rawMarkers, mapRef, mapApi, selectedThemeColor) {
    this.rawMarkers = rawMarkers;
    this.mapRef = mapRef;
    this.mapApi = mapApi;
    this.infowindows = [];

    const styles = this.getClusterStyle(selectedThemeColor);

    this.createMarkers(mapRef, selectedThemeColor);
    // this.markerCluster = new MarkerClusterer(this.mapRef, this.markers, {
    //   styles,
    // });

    this.mapApi.event.addListener(this.mapRef, 'zoom_changed', () => {
      this.currentInfowindow && this.currentInfowindow.close();
    });

    this.processSize = this.processSize.bind(this);
  }

  processSize(size) {
    var temp = size.split(' ');
    return parseFloat(temp[0]) + ' ' + temp[1];
  }

  createMarkers(mapRef, selectedThemeColor) {
    const SnazzyInfoWindow = require('snazzy-info-window');

    this.markers = this.rawMarkers.map(markerObj => {
      //console.log(markerObj.location);
      const marker = new this.mapApi.Marker({
        position: markerObj.location,
        map: this.mapRef,
        icon: this.getGoogleMarkerInlineSvg(selectedThemeColor)
      });

      const contentObj = markerObj.content;

      let hr_by = '';
      if (contentObj.supportingAgencies && contentObj.supportingAgencies != null) {
        hr_by += contentObj.supportingAgencies + ', ';
      }
      if (contentObj.leadAgency) {
        hr_by += contentObj.leadAgency;
      }

      const infoContent = `<div class="o__infowindow">
        <div class="info__heading">
          <h5>${contentObj.location}</h5>
        </div>

        <div class="info__content">
          <ul>
            <li>
              <span>Location:</span>
              <span>${contentObj.lga}</span>
            </li>
            <li>
              <span>Date:</span>
              <span>
                ${contentObj.startDate}
                ${' - '}
                ${contentObj.endDate}
              </span>
            </li>
            <li>
              <span>Tenure:</span>
              <span>${contentObj.tenure}</span>
            </li>
            <li>
              <span>HR By:</span>
              <span>
                ${hr_by}
              </span>
            </li>
            <li>
              <span>Size:</span>
              <span>${this.processSize(contentObj.size)}</span>
            </li>
          </ul>
        </div>
      </div>`;

      const setCurrentinfoWindow = infoWindow => {
        this.currentInfowindow = infoWindow;
      };

      const infowindow = new SnazzyInfoWindow({
        marker,
        content: infoContent,
        padding: '0px',
        openOnMarkerClick: true,
        closeWhenOthersOpen: true,
        showCloseButton: true,
        callbacks: {
          open: function () {
            setCurrentinfoWindow(this);
          },
        },
      });

      return marker;
    });
  }

  clearMarkers() {
    this.markerCluster.removeMarkers(this.markers);
  }

  addMarkers() {
    this.markerCluster.addMarkers(this.markers);
  }

  getGoogleClusterInlineSvg(color) {
    const encoded = window.btoa(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 37 37">
      <g fill="none" fill-rule="evenodd">
          <circle cx="18.5" cy="18.5" r="14.4" stroke="${color}" stroke-width="2.2" opacity=".8"/>
          <circle cx="18.5" cy="18.5" r="17.4" stroke="${color}" stroke-width="2.2" opacity=".502"/>
          <circle cx="18.5" cy="18.5" r="12.5" fill="${color}"/>
      </g>
    </svg>
    `);

    return 'data:image/svg+xml;base64,' + encoded;
  }

  getGoogleMarkerInlineSvg() {
    const encoded = window.btoa(`<?xml version="1.0" encoding="UTF-8"?>
    <svg width="29px" height="28px" viewBox="0 0 29 28" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <title>Fire / black</title>
      <desc>Created with Sketch.</desc>
      <g id="Fire-/-black" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <polygon id="Path" fill="#000000" fill-rule="nonzero" points="0 13.6 14.1 27.3 28.3 13.6 14.1 0"></polygon>
          <path d="M8.9,19.2 L14.2,24.3 L19.5,19.2 C20.4,18.4 21.2,17.3 21.7,16.2 C22.2,15.1 22.3,14.1 22.3,14.1 C21.1,15.5 19.8,15.3 19.8,15.2 C21.3,13.6 21.1,11.3 21.1,11.3 C19.8,13.2 18.3,12.5 18.3,12.5 C20,10.2 18.3,7.8 18.3,7.8 C18.2,10.5 15.5,11 14.6,9.5 C13.4,7.6 15.6,4.5 15.6,4.5 C9.8,7.8 11.7,12.4 11.7,12.4 C9.3,12 8.2,9.2 8.2,9.2 C7.4,12.4 8.8,15.2 8.8,15.2 C7.5,15.1 6.4,13.7 6.4,13.7 C6.6,16.8 8.5,18.7 8.5,18.7 L8.9,19.2 Z" id="Path" fill="#FFFFFF" fill-rule="nonzero"></path>
      </g>
  </svg>
    `);

    return 'data:image/svg+xml;base64,' + encoded;
  }

  getClusterStyle(color) {
    return [
      {
        url: this.getGoogleClusterInlineSvg(color),
        textColor: '#ffffff',
        width: 25,
        height: 25,
      },
      {
        url: this.getGoogleClusterInlineSvg(color),
        textColor: '#ffffff',
        width: 30,
        height: 30,
      },
      {
        url: this.getGoogleClusterInlineSvg(color),
        textColor: '#ffffff',
        width: 40,
        height: 40,
      },
      {
        url: this.getGoogleClusterInlineSvg(color),
        textColor: '#ffffff',
        width: 50,
        height: 50,
      },
    ];
  }
}

export default MapCluster;
